import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { Link } from 'react-router-dom';
import config from '../../../helpers/config';

const useStyles = makeStyles(theme => ({

    facilityIntro: props => ({
        margin: '150px 0px',
        padding: '100px 0px 125px 0px',
        position: 'relative',
        background: 'linear-gradient(45deg, #d0eaee, #fcfeff)',

        '& .background': {
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundSize: 'contain',
            backgroundPosition: '0% 50%',
            backgroundRepeat: 'no-repeat',
            backgroundImage: props && props.facilityIntro ? `url(${config.S3Endpoint}${props.facilityIntro.imgUrl})` : ''
        },

        '& .title': {
            color: '#1a2188',
            textAlign: 'center',
            paddingBottom: '50px',
            letterSpacing: '15px',
        },

        '& .description': {
            textAlign: 'center',
            letterSpacing: '10px',
            '& h4': {
                display: 'inline-block',
                padding: '0px 20%',
                lineHeight: '40px',
                [theme.breakpoints.down("xs")]: { 
                    padding: '0px 15px',
                    letterSpacing: '5px',
                    width: '80%'
                },
                [theme.breakpoints.up("xs")]: {
                    padding: '0px 5%',
                    letterSpacing: '10px',
                    width: '80%'
                },
                [theme.breakpoints.up("sm")]: {
                    padding: '0px 10%',
                    letterSpacing: '10px',
                    width: '80%'
                },
                [theme.breakpoints.up("md")]: {
                    padding: '0px 10%',
                    letterSpacing: '10px',
                    width: '80%'
                },
                [theme.breakpoints.up("lg")]: {
                },
            }
        }
    }),

    facilityDetail: props => ({
        margin: '50px 100px',
        padding: '75px 0px',
        position: 'relative',
                
        [theme.breakpoints.down("xs")]: { 
            margin: '0px',
        },
        [theme.breakpoints.up("xs")]: {
            margin: '50px',
        },
        [theme.breakpoints.up("sm")]: {
            margin: '50px',
        },
        [theme.breakpoints.up("md")]: {
            padding: '50px 0px',
            margin: '50px 50px',
        },
        [theme.breakpoints.up("lg")]: {
            padding: '75px 0px',
            margin: '50px 100px',
        },


        '& .facilitySection': {
            
            '& .facilityImgSection': {
                position: 'relative',
                height: '35vw',
                width: '100%',
                marginBottom: '50px',
                
                [theme.breakpoints.down("xs")]: { 
                    height: '70vw',
                },
                [theme.breakpoints.up("xs")]: {
                    height: '60vw',
                },
                [theme.breakpoints.up("sm")]: {
                    height: '50vw',
                },
                [theme.breakpoints.up("md")]: {
                    height: '45vw',
                },
                [theme.breakpoints.up("lg")]: {
                    height: '35vw',
                },

                '& .facilityImg': {
                    position: 'absolute',
                    width: '75%',
                    height: '90%',
                    backgroundSize: 'contain',
                    backgroundPosition: '0%',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    zIndex: 1,
                    boxShadow: 'inset 0px 0px 200px #dadada',
                
                    [theme.breakpoints.down("xs")]: { 
                        width: '90%',
                    },
                    [theme.breakpoints.up("xs")]: {
                        width: '85%',
                    },
                    [theme.breakpoints.up("sm")]: {
                        width: '85%',
                    },
                    [theme.breakpoints.up("md")]: {
                        width: '80%',
                    },
                    [theme.breakpoints.up("lg")]: {
                        width: '75%',
                    },

                    '& .title': {
                        position: 'absolute',
                        bottom: '50px',
                        height: '40px',
                        backgroundColor: 'rgba(255, 255, 255, 0.8)',
                        padding: '25px 50px 25px 50px',
                        maxWidth: '25%',
                        transition: 'all 300ms linear',

                        '& a': {
                            textDecoration: 'none'
                        },
                        '&.even': {
                            right: '0px',
                            borderTopLeftRadius: '50px',
                            borderBottomLeftRadius: '50px',
                            textAlign: 'left'
                        },

                        '&.odd': {
                            left: '0px',
                            borderTopRightRadius: '50px',
                            borderBottomRightRadius: '50px',
                            textAlign: 'right'
                        },
                    
                        '& h3': {
                            color: "#b8538d"
                        },

                        '& h4': {
                            visibility: 'hidden',
                            height: '0px',
                            opacity: '0'
                        },

                        '&:hover h4': {
                            paddingTop: '15px',
                            transition: 'height 300ms linear',
                            visibility: 'visible',
                            height: 'auto',
                            width: 'auto',
                            opacity: '1'
                        }
                    },
                    '& .title:hover': { 
                        height: '120px'
                    }
                },

                '& .facilityBorder': {
                    position: 'absolute',
                    zIndex: 0,

                    '&.f1': {
                        top: 0,
                        right: 0,
                        width: 0,
                        height: 0,
                        borderTop: '0px solid transparent',
                    
                        [theme.breakpoints.down("xs")]: { 
                            borderLeft: 'calc(90vw - 0px) solid #d8abc6', // (75vw -200) * 0.75 + 50
                            borderBottom: 'calc(35vw - 0px) solid transparent',
                        },
                        [theme.breakpoints.up("xs")]: {
                            borderLeft: 'calc(85vw - 50px) solid #d8abc6', // (75vw -200) * 0.75 + 50
                            borderBottom: 'calc(30vw - 0px) solid transparent',
                        },
                        [theme.breakpoints.up("sm")]: {
                            borderLeft: 'calc(85vw - 50px) solid #d8abc6', // (75vw -200) * 0.75 + 50
                            borderBottom: 'calc(25vw - 0px) solid transparent',
                        },
                        [theme.breakpoints.up("md")]: {
                            borderLeft: 'calc(80vw - 100px) solid #d8abc6', // (75vw -200) * 0.75 + 50
                            borderBottom: 'calc(23vw - 0px) solid transparent',
                        },
                        [theme.breakpoints.up("lg")]: {
                            borderLeft: 'calc(75vw - 100px) solid #d8abc6', // (75vw -200) * 0.75 + 50
                            borderBottom: 'calc(17vw - 0px) solid transparent',
                        }
                    },
                    '&.f2': {
                        backgroundColor: '#aadbde',
                        left: 0,
                        top: '2.5%',
                        height: '90%',

                        [theme.breakpoints.down("xs")]: { 
                            width: 'calc(90% + 50px)',
                        },
                        [theme.breakpoints.up("xs")]: {
                            width: 'calc(85% + 50px)',
                        },
                        [theme.breakpoints.up("sm")]: {
                            width: 'calc(85% + 50px)',
                        },
                        [theme.breakpoints.up("md")]: {
                            width: 'calc(80% + 50px)',
                        },
                        [theme.breakpoints.up("lg")]: {
                            width: 'calc(75% + 50px)',
                        }

                    },
                    '&.f3': {
                        bottom: 0,
                        right: 0,
                        width: 0,
                        height: 0,
                        borderTop: 'calc(17vw - 0px) solid transparent',
                        borderLeft: 'calc(75vw - 100px) solid #b897c5', // (75vw -200) * 0.75 + 50
                        borderBottom: '0px solid transparent',
                        

                        [theme.breakpoints.down("xs")]: { 
                            borderTop: 'calc(35vw - 0px) solid transparent',
                            borderLeft: 'calc(90vw - 0px) solid #b897c5', // (75vw -200) * 0.75 + 50    
                        },
                        [theme.breakpoints.up("xs")]: {
                            borderTop: 'calc(30vw - 0px) solid transparent',
                            borderLeft: 'calc(85vw - 50px) solid #b897c5', // (75vw -200) * 0.75 + 50    
                        },
                        [theme.breakpoints.up("sm")]: {
                            borderTop: 'calc(25vw - 0px) solid transparent',
                            borderLeft: 'calc(85vw - 50px) solid #b897c5', // (75vw -200) * 0.75 + 50    
                        },
                        [theme.breakpoints.up("md")]: {
                            borderTop: 'calc(23vw - 0px) solid transparent',
                            borderLeft: 'calc(80vw - 100px) solid #b897c5', // (75vw -200) * 0.75 + 50    
                        },
                        [theme.breakpoints.up("lg")]: {
                            borderTop: 'calc(17vw - 0px) solid transparent',
                            borderLeft: 'calc(75vw - 100px) solid #b897c5', // (75vw -200) * 0.75 + 50    
                        }

                    },
                }
            }
        },
    }),

}));


const FacilityIntro = (props) => {
    const classes = useStyles(props), 
        {facilityIntro} = props;
    if (!facilityIntro) {
        return (<div></div>)
    }

    return (
        <div id="facilityIntro" className={classes.facilityIntro}>
            <div className="background"></div>
            <div className="title">
                <Typography variant="h2"><b>{facilityIntro.name}</b></Typography>
            </div>
            <div className="description">
                {facilityIntro.desc.map((d, i) => <Typography key={i} variant="h4">{d}</Typography>)}
            </div>
        </div>
    )
}

const FacilityDetail = (props) => {
    const classes = useStyles(props), 
        {facilityDetail} = props;
    if (!facilityDetail) {
        return (<div></div>)
    }
    return (
        <div className={classes.facilityDetail}>
            <div className="facilitySection">
                {facilityDetail.facilities.map((d, i) => {
                    var top = ["5%", "2.5%", "0"],
                        even = i % 2 === 0,
                        facilityImgStyle = {
                            backgroundImage: `url(${config.S3Endpoint}${d.imgUrl})`,
                            right: even ? 0 : 'auto',
                            left: even ? 'auto' : 0,
                            top: top[i],
                        },
                        facilityBorderStyle = {
                            
                        }
                    return (
                        <div key={i} className="facilityImgSection">
                            <div className="facilityImg" style={facilityImgStyle}>
                                <div className={`title ${even ? 'even' : 'odd'}`}>
                                    {d.linkUrl ?
                                        <Link to={d.linkUrl}><Typography variant="h3"><b>{d.name}</b></Typography> </Link> :
                                        <Typography variant="h3"><b>{d.name}</b></Typography>
                                    }
                                    <Typography variant="h4">{d.summary}</Typography>
                                </div>
                            </div>
                            <div className={`facilityBorder f${i+1}`}  style={facilityBorderStyle} />
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default (props) => {
    return (
        <React.Fragment>
            <FacilityIntro {...props} />
            <FacilityDetail {...props} />
        </React.Fragment>
    )
}



// WEBPACK FOOTER //
// ./src/client/components/tour/Facility.js